import { Inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@shared/providers/environment.provider';
import { HttpClient } from '@angular/common/http';
import { Environment } from '../../types/environment';
import { Seller } from '../../types/seller';
import { Carrier } from '../../types/carrier';

@Injectable({
  providedIn: 'root',
})
export class CarrierService {
  readonly API = `${this.env.apiUrl}/carrierClassifier`;

  constructor(
    @Inject(APP_ENVIRONMENT) private readonly env: Environment,
    private readonly http: HttpClient,
  ) {}

  save(carrier: Carrier) {
    return this.http.post<Carrier>(`${this.API}/save`, carrier);
  }

  deleteById(id: number) {
    return this.http.post<void>(`${this.API}/deleteById?id=${id}`, null);
  }

  getById(id: number) {
    return this.http.get<Seller>(`${this.API}/getById?id=${id}`);
  }

  getAll(name?: string) {
    let url = `${this.API}/getAll`;
    if (name) {
      url += `?name=${name}`;
    }
    return this.http.get<Carrier[]>(url);
  }

  toCarrierMap(value: Carrier[], key: keyof Carrier): Map<string, Carrier> {
    return value.reduce((previousValue, currentValue) => {
      return previousValue.set(currentValue[key]?.toString(), currentValue);
    }, new Map());
  }
}
